import { Translation } from 'cng-common/features/translations/components/translation'
import { getFormatDate } from 'core/classes/helpers/DateHelper'

import { TRANSLATION_KEYS } from '../../translations/TRANSLATION_KEYS'

import { DNA_DATE_REPLACE_TRANSLATION_KEY } from './configs'

import styles from './DnALoadDate.module.scss'

interface IProps {
  dnaLoadDate: string | null
}

export const DnALoadDate = ({ dnaLoadDate }: IProps) => {
  if (!dnaLoadDate) {
    return null
  }

  return (
    <div className={styles.root}>
      <Translation
        text={TRANSLATION_KEYS.dnaLoadDate}
        replaceParams={[
          {
            key: DNA_DATE_REPLACE_TRANSLATION_KEY,
            value: `${getFormatDate(dnaLoadDate, 'date')}`,
          },
        ]}
      />
    </div>
  )
}
